function UserTable({ users, loading, onUserClick }) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="admin-loader"></div>
      </div>
    );
  }

  if (!users || users.length === 0) {
    return (
      <div className="empty-state">
        <p className="empty-state-description">Пользователи не найдены</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Пользователь</th>
            <th>Telegram ID</th>
            <th>Тип подписки</th>
            <th>Документов</th>
            <th>Дата регистрации</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr 
              key={user.id} 
              onClick={() => onUserClick && onUserClick(user)}
              className="cursor-pointer hover-row"
            >
              <td className="font-semibold">#{user.id}</td>
              <td>
                <div className="font-medium text-gray-900">
                  {user.first_name} {user.last_name}
                </div>
                <div className="text-xs text-gray-500">@{user.username || 'N/A'}</div>
              </td>
              <td className="text-gray-600">{user.telegram_id}</td>
              <td>
                <span className={user.subscription_type === 'free' ? 'badge badge-gray' : 'badge badge-success'}>
                  {user.subscription_type}
                </span>
              </td>
              <td className="text-gray-600">{user.documents_signed_count}</td>
              <td className="text-gray-600">
                {new Date(user.created_at).toLocaleDateString('ru-RU', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UserTable;

